import { createTheme } from '@mui/material/styles';
import colors from 'assets/scss/_themes-vars.module.scss';
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';

/**
 * Generate the theme using Material-UI createTheme
 * @param {Object} customization - Customization settings
 */
export const theme = (customization) => {
    const color = colors;

    const themeOption = {
        colors: color,
        heading: color.grey900,
        paper: color.paper,
        backgroundDefault: color.paper,
        background: color.grey100,
        darkTextPrimary: color.grey700,
        darkTextSecondary: color.grey500,
        textDark: color.grey900,
        menuSelected: color.secondaryDark,
        menuSelectedBack: color.secondaryLight,
        divider: color.grey200,
        customization,
    };

    const themeOptions = {
        direction: 'ltr',
        palette: themePalette(themeOption),
        typography: themeTypography(themeOption),
        mixins: {
            toolbar: {
                padding: '8px 16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px',
                },
            },
        },
    };

    const themes = createTheme(themeOptions);
    themes.components = componentStyleOverrides(themeOption);

    return themes;
};

export default theme;